<template>
	<div>
		<div class="row mb-2">
			<div class="col-5">
				<h1>{{$t('osce-dashboard')}}</h1>
			</div>
			<div class="col-7">
				<MenuModalBtn class="float-right"/>
			</div>
		</div>
        <div class="row">
			<div class="col-12 col-lg-8 order-lg-1 mb-1">
            <OSCEInfo
                :exam-title="examTitle"
                :examiner-name="examinerName"
                :connection-status="connectionStatus"
            />
            </div>
        </div>
		<div class="row">
			<div class="col-12 col-lg-4 order-lg-12 mb-4">
               <OSCEHelper
                    :current-station="currentStation"
                    :current-candidate="currentCandidate"
                    :stations="stations"
                    :candidates="candidates"
                    :time-remaining="timeRemaining"
                    @station-change="handleStationChange"
                    @candidate-change="handleCandidateChange"
                />
			</div>

			<div class="col-12 col-lg-8 order-lg-1">
                <OSCECurrent
                    :station="currentStation"
                    :candidate="currentCandidate"
                    :initial-scores="currentScores"
                    @criteria-scored="handleCriteriaScored"
                    @global-scores-updated="handleGlobalScoresUpdated"
                    @auto-save="handleAutoSave"
                    @manual-save="handleManualSave"
                    @station-complete="handleStationComplete"
                    @next-candidate="handleNextCandidate"
                    @save-error="handleSaveError"
                    ref="gradingInterface"
                /> 
                
			</div>
		</div>
	</div>
</template>

<script>
import MenuModalBtn from "src/components/Workflows/MenuModalBtn.vue";
// FeedbackWidget from "src/components/widgets/OSCE/FeedbackWidget";
//import LongitudinalTrackingWidget from "src/components/widgets/OSCE/LongitudinalTrackingWidget";
//import ReportWidget from "src/components/widgets/ReportWidget";
//import Table from "src/components/Table/Table.vue";
import OSCEHelper from "src/components/OSCE/OSCEHelper.vue";

import OSCECurrent from "src/components/OSCE/OSCECurrent.vue";
import OSCEInfo from "src/components/OSCE/OSCEInfo.vue";


export default {
	components: {
		MenuModalBtn,
        //ReportWidget,
        //FeedbackWidget,
        //Table,
        //LongitudinalTrackingWidget,
        OSCEHelper,
        OSCEInfo,
        OSCECurrent
	},
    mounted() {
    this.initializeData();
    this.startTimer();
    this.setupAutoSave();
    this.initializeDashboard()
    this.setupGlobalEventListeners()
  },
  
  beforeDestroy() {
    this.clearTimer();
       this.cleanupGlobalEventListeners()

  },
	computed: {
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
		},
         // Calculate completion progress
    completionProgress() {
      if (!this.currentStation || !this.currentStation.criteria) return 0;
      
      const totalCriteria = this.currentStation.criteria.length;
      const completedCriteria = this.currentStation.criteria.filter(
        criterion => this.currentScores[criterion.id] !== undefined && 
                   this.currentScores[criterion.id] !== null
      ).length;
      
      return totalCriteria > 0 ? (completedCriteria / totalCriteria) * 100 : 0;
    },
    
    // Navigation helpers
    hasPreviousCandidate() {
      const currentIndex = this.candidates.findIndex(c => c.id === this.currentCandidate?.id);
      return currentIndex > 0;
    },
    
    hasNextCandidate() {
      const currentIndex = this.candidates.findIndex(c => c.id === this.currentCandidate?.id);
      return currentIndex < this.candidates.length - 1;
    },
    
    // Formatted time for display
    formattedTime() {
      const minutes = Math.floor(this.timeRemaining / 60);
      const seconds = this.timeRemaining % 60;
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
     stationCandidates() {
      if (!this.currentStation) return []
      return this.candidates.filter(c => c.station === this.currentStation.id)
    }
	},
    data() {
        const today = new Date();
        const past = new Date(today);
        past.setDate(today.getDate() - 31);

        const future = new Date(today);
        future.setDate(today.getDate()+7);

        return {
            osces:[
                {
                    id: 'APP2J01',
                    title: 'Urine analysis',
                    description: 'The student will perform an urine analysis',
                    marked: true,
                    skill: 'Diagnostic procedures',
                    timestamp: '1763119518',
                    teacher_displayname: 'Indy Dehele',
                    score: 80
                },
                {
                    id: 'APP2S03',
                    title: 'Accuracy check',
                    description: 'The student will perform an accuracy check',
                    marked: true,
                    skill: 'Professional technical',
                    timestamp: '1663115518',
                    teacher_displayname: 'John Doe',
                    score: 50
                },
                {
                    id: 'APP3J03',
                    title: 'Ear Examination',
                    description: 'Students perform an ear examination using an otoscope on a mannequin, diagnose a basic pathology and make recommendations for patient counselling',
                    marked: true,
                    skill: 'Diagnostic Examination',
                    timestamp: '1661115518',
                    teacher_displayname: 'Jane Doe',
                    score: 90
                }
            ],
            total_count: 0,
            loading: false,
            submitting: false,
            showadvancedsearch:false,
            students:[],
            ready:false,
            ttsessiontypes:[],
            ttrooms:[],
            filters: {
                page: 1,
                page_size: 30,
                search: '',
                order: '',
                programme: '',
                year: '',
                attended: false,
                absent: true,
                unknown: true,
                students: [],
                datetime_from: past.toISOString().split('T')[0],
                datetime_to: future.toISOString().split('T')[0]
            },
            downloading: false,
            
             // Exam data
            examTitle: 'Final Year OSCE - Day 1',
            examinerName: 'Dr. Smith',
            
            // Current state
            currentStation: {},
            currentCandidate: {},
            currentScores: {},
            
            // UI state
            connectionStatus: 'connected',
            timeRemaining: 600, // 10 minutes in seconds
            isSaving: false,
            showSaveNotification: false,
            timerInterval: null,
            
            // Mock data - in real app, this would come from API
            stations: [
                { id: 1, name: 'Station 1: History Taking', duration: 600 },
                { id: 2, name: 'Station 2: Cardiovascular Exam', duration: 600 },
                { id: 3, name: 'Station 3: Abdominal Examination', duration: 600 },
                { id: 4, name: 'Station 4: Respiratory Exam', duration: 600 },
                { id: 5, name: 'Station 5: Neurology Exam', duration: 600 }
            ],
            
            candidates: [
                { id: '12345', name: 'Jane Doe', station: 3, flagged: false },
                { id: '12346', name: 'John Smith', station: 3, flagged: true },
                { id: '12347', name: 'Alice Johnson', station: 3, flagged: false }
            ]
                    //item:{}
        }
    },
    methods: {
        selectItem(item){
        	this.$router.push(`/attendance/register/${item.ttevent_id}`);
        },
        scoreIcon(item){
            if(item.score >= 90) return { icon: 'check-circle-fill', variant: 'success' };
            if(item.score <= 50) return { icon: 'x-circle-fill', variant: 'danger' };
            return { icon: 'exclamation-circle-fill', variant: 'warning'}
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters, page: 1 }
            this.fetchReport()
        },
        toPage(pageNo) {
            this.filters.page = pageNo
            this.fetchReport()
        },
        initializeData() {
      // Set initial station and candidate
      this.currentStation = this.stations[1]; // Start with station 3
      this.currentCandidate = this.candidates[0];
      
      // Load initial scores
      this.loadScores();
    },
    
    startTimer() {
      this.timerInterval = setInterval(() => {
        if (this.timeRemaining > 0) {
          this.timeRemaining--;
        } else {
          this.handleTimeUp();
        }
      }, 1000);
    },
    
    clearTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
    },
    
    handleTimeUp() {
      this.clearTimer();
      this.$emit('time-up', {
        station: this.currentStation,
        candidate: this.currentCandidate
      });
      
      // Auto-save when time is up
      this.autoSave();
    },
    
    // Station navigation
    handleStationChange(stationId) {
      const newStation = this.stations.find(s => s.id === stationId);
      if (newStation && newStation.id !== this.currentStation.id) {
        // Save current work before switching
        this.autoSave().then(() => {
          this.currentStation = newStation;
          this.timeRemaining = newStation.duration;
          this.loadScores();
        });
      }
    },
    
    // Candidate navigation
    handleCandidateChange(candidateId) {
      const newCandidate = this.candidates.find(c => c.id === candidateId);
      if (newCandidate && newCandidate.id !== this.currentCandidate.id) {
        this.autoSave().then(() => {
          this.currentCandidate = newCandidate;
          this.loadScores();
        });
      }
    },
    
    goToPreviousCandidate() {
      if (!this.hasPreviousCandidate) return;
      
      const currentIndex = this.candidates.findIndex(c => c.id === this.currentCandidate.id);
      this.handleCandidateChange(this.candidates[currentIndex - 1].id);
    },
    
    goToNextCandidate() {
      if (!this.hasNextCandidate) return;
      
      const currentIndex = this.candidates.findIndex(c => c.id === this.currentCandidate.id);
      this.handleCandidateChange(this.candidates[currentIndex + 1].id);
    },
    
    // Score management
    handleScoresUpdate({ criterionId, score, comments }) {
      this.$set(this.currentScores, criterionId, {
        score,
        comments,
        timestamp: new Date().toISOString()
      });
      
      // Trigger auto-save
      this.debouncedAutoSave();
    },
    
    
    // Auto-save functionality
    setupAutoSave() {
      this.debouncedAutoSave = this.$debounce(this.autoSave, 2000);
    },
    
    async autoSave() {
      this.isSaving = true;
      this.showSaveNotification = true;
      
      try {
        // Simulate API call
        await this.$api.saveScores({
          stationId: this.currentStation.id,
          candidateId: this.currentCandidate.id,
          scores: this.currentScores,
          examiner: this.examinerName
        });
        
        // Also save to localStorage as backup
        const key = `scores_${this.currentStation.id}_${this.currentCandidate.id}`;
        localStorage.setItem(key, JSON.stringify(this.currentScores));
        
        // Hide notification after delay
        setTimeout(() => {
          this.showSaveNotification = false;
        }, 3000);
        
      } catch (error) {
        console.error('Auto-save failed:', error);
        this.$emit('save-error', error);
      } finally {
        this.isSaving = false;
      }
    },
    
    manualSave() {
      this.autoSave();
    },
    
    toggleFlag() {
      this.currentCandidate.flagged = !this.currentCandidate.flagged;
      this.debouncedAutoSave();
    },
    
    updateProgress() {
      // Emit progress updates if needed for parent component
      this.$emit('progress-update', this.completionProgress);
    },
    initializeDashboard() {
      // Set initial station and candidate
      this.currentStation = this.stations[0]
      this.currentCandidate = this.stationCandidates[0]
      
      // Load initial scores
      this.loadScores()
    },
    
    // Load scores from backend or local storage
    async loadScores() {
      try {
        const scores = await this.$api.getScores(
          this.currentStation.id,
          this.currentCandidate.id
        )
        this.currentScores = scores || {}
      } catch (error) {
        console.error('Failed to load scores:', error)
        this.currentScores = {}
      }
    },
    
    // Handle station changes from sidebar
    // async handleStationChange(stationId) {
    //   const newStation = this.stations.find(s => s.id === stationId)
      
    //   if (!newStation) {
    //     console.warn('Station not found:', stationId)
    //     return
    //   }
      
    //   // Check for unsaved changes
    //   if (this.hasUnsavedChanges) {
    //     this.pendingNavigation = { type: 'station', stationId }
    //     this.showNavigationConfirm = true
    //     return
    //   }
      
    //   await this.performStationChange(newStation)
    // },
    
    // Handle candidate changes from sidebar
    // async handleCandidateChange(candidateId) {
    //   const newCandidate = this.candidates.find(c => c.id === candidateId)
      
    //   if (!newCandidate) {
    //     console.warn('Candidate not found:', candidateId)
    //     return
    //   }
      
    //   // Check for unsaved changes
    //   if (this.hasUnsavedChanges) {
    //     this.pendingNavigation = { type: 'candidate', candidateId }
    //     this.showNavigationConfirm = true
    //     return
    //   }
      
    //   await this.performCandidateChange(newCandidate)
    // },
    
    // Perform the actual station change
    async performStationChange(newStation) {
      // Save current state if needed
      if (this.hasUnsavedChanges) {
        await this.$refs.gradingInterface.saveGrading()
      }
      
      // Update current station
      this.currentStation = newStation
      
      // Get first candidate for new station
      this.currentCandidate = this.stationCandidates[0] || null
      
      // Load scores for new station/candidate
      await this.loadScores()
      
      this.hasUnsavedChanges = false
      this.showNavigationConfirm = false
    },
    
    // Perform the actual candidate change
    async performCandidateChange(newCandidate) {
      // Save current state if needed
      if (this.hasUnsavedChanges) {
        await this.$refs.gradingInterface.saveGrading()
      }
      
      // Update current candidate
      this.currentCandidate = newCandidate
      
      // Load scores for new candidate
      await this.loadScores()
      
      this.hasUnsavedChanges = false
      this.showNavigationConfirm = false
    },
    
    // Navigation confirmation handlers
    proceedWithNavigation() {
      if (!this.pendingNavigation) return
      
      if (this.pendingNavigation.type === 'station') {
        const station = this.stations.find(s => s.id === this.pendingNavigation.stationId)
        if (station) {
          this.performStationChange(station)
        }
      } else if (this.pendingNavigation.type === 'candidate') {
        const candidate = this.candidates.find(c => c.id === this.pendingNavigation.candidateId)
        if (candidate) {
          this.performCandidateChange(candidate)
        }
      }
      
      this.pendingNavigation = null
    },
    
    cancelNavigation() {
      this.pendingNavigation = null
      this.showNavigationConfirm = false
    },
    
    // ===== GradingInterface Event Handlers =====
    
    // When a criterion is scored
    handleCriteriaScored(eventData) {
      console.log('Criterion scored:', eventData)
      
      // Update local state if needed
      this.hasUnsavedChanges = true
      
      // Emit analytics or update progress in parent
      this.$emit('grading-progress', {
        stationId: this.currentStation.id,
        candidateId: this.currentCandidate.id,
        completion: eventData.completion
      })
    },
    
    // When global scores are updated
    handleGlobalScoresUpdated(globalScores) {
      console.log('Global scores updated:', globalScores)
      this.hasUnsavedChanges = true
    },
    
    // When auto-save completes
    handleAutoSave(eventData) {
      console.log('Auto-save completed:', eventData)
      
      if (eventData.success) {
        this.hasUnsavedChanges = false
        
        // Show subtle notification
        this.$notify({
          type: 'success',
          title: 'Progress Saved',
          message: 'Your changes have been auto-saved',
          duration: 2000
        })
      }
    },
    
    // When manual save is triggered
    handleManualSave(eventData) {
      console.log('Manual save completed:', eventData)
      
      if (eventData.success) {
        this.hasUnsavedChanges = false
        
        // Show confirmation
        this.$notify({
          type: 'success',
          title: 'Saved',
          message: 'All scores have been saved successfully',
          duration: 3000
        })
      }
    },
    
    // When save fails
    handleSaveError(error) {
      console.error('Save error:', error)
      
      this.$notify({
        type: 'error',
        title: 'Save Failed',
        message: 'Unable to save scores. Please try again.',
        duration: 5000
      })
    },
    
    // When examiner marks station as complete
    handleStationComplete(eventData) {
      console.log('Station completed:', eventData)
      
      // Update station status
      this.$api.markStationComplete(
        this.currentStation.id,
        this.currentCandidate.id,
        eventData
      )
      
      this.$notify({
        type: 'success',
        title: 'Station Completed',
        message: `${this.currentCandidate.name} has completed ${this.currentStation.name}`,
        duration: 4000
      })
      
      // Auto-advance to next candidate if available
      this.autoAdvanceToNextCandidate()
    },
    
    // When next candidate is requested
    handleNextCandidate(eventData) {
      console.log('Next candidate requested:', eventData)
      this.autoAdvanceToNextCandidate()
    },
    
    // Auto-advance to next candidate
    autoAdvanceToNextCandidate() {
      const currentIndex = this.stationCandidates.findIndex(
        c => c.id === this.currentCandidate.id
      )
      
      if (currentIndex < this.stationCandidates.length - 1) {
        // Go to next candidate
        const nextCandidate = this.stationCandidates[currentIndex + 1]
        this.performCandidateChange(nextCandidate)
      } else {
        // No more candidates, go to next station or show completion
        this.$notify({
          type: 'info',
          title: 'All Candidates Graded',
          message: 'All candidates for this station have been completed.',
          duration: 5000
        })
      }
    },
    
    // Global event listeners
    setupGlobalEventListeners() {
      // Handle browser beforeunload for unsaved changes
      window.addEventListener('beforeunload', this.handleBeforeUnload)
      
      // Global keyboard shortcuts
      document.addEventListener('keydown', this.handleGlobalKeydown)
    },
    
    cleanupGlobalEventListeners() {
      window.removeEventListener('beforeunload', this.handleBeforeUnload)
      document.removeEventListener('keydown', this.handleGlobalKeydown)
    },
    
    // Warn about unsaved changes when leaving page
    handleBeforeUnload(event) {
      if (this.hasUnsavedChanges) {
        event.preventDefault()
        event.returnValue = 'You have unsaved changes. Are you sure you want to leave?'
        return event.returnValue
      }
    },
    
    // Global keyboard shortcuts
    handleGlobalKeydown(event) {
      // Ctrl+Alt+N for next candidate
      if (event.ctrlKey && event.altKey && event.key === 'n') {
        event.preventDefault()
        this.autoAdvanceToNextCandidate()
      }
      
      // Ctrl+Alt+P for previous candidate
      if (event.ctrlKey && event.altKey && event.key === 'p') {
        event.preventDefault()
        this.autoAdvanceToPreviousCandidate()
      }
    },
    
    autoAdvanceToPreviousCandidate() {
      const currentIndex = this.stationCandidates.findIndex(
        c => c.id === this.currentCandidate.id
      )
      
      if (currentIndex > 0) {
        const prevCandidate = this.stationCandidates[currentIndex - 1]
        this.performCandidateChange(prevCandidate)
      }
    },
    
    // Method to programmatically trigger save from parent
    triggerSave() {
      if (this.$refs.gradingInterface) {
        this.$refs.gradingInterface.saveGrading()
      }
    },
    
    // Method to reset scores for current candidate
    async resetCurrentScores() {
      if (this.$refs.gradingInterface) {
        this.$refs.gradingInterface.resetScores()
        this.hasUnsavedChanges = true
      }
    },
    
    // Method to get current grading data
    getCurrentGradingData() {
      if (this.$refs.gradingInterface) {
        return this.$refs.gradingInterface.getCurrentState()
      }
      return null
    }
    },
    
};
</script>
